const mainUa = {
  projectText: 'Проєкт трансформації свідомості',
  heroChoose: 'Обери свою дію, яка змінить тебе і весь світ!',
  heroButton1: 'Перейти до послуг',
  heroButton2: 'Калькулятор матриці',
  projectAuthor: 'Автор проєкту',
  authroDesc:
    '<0>Дарина Дупак</0> — Професійний ініційований консультант із призначення, діагностики та корекції долі.',
  aboutAuthorWork1: 'Дипломований менеджер соціокультурної діяльності',
  aboutAuthorWork2:
    'Проводжу трансформаційні івенти. Працюю над створенням особистісних брендів.',
  aboutAuthorWork3:
    'Працюю за авторським методом Наталії Ладіні, відомого як Матриця Долі.',
  aboutAuthorWork4:
    'Володію поглибленими розрахунками методу і техніками зцілення.',
  aboutAuthorWork5:
    'Здобула ступінь магістра психології в Національному університеті імені В. І. Вернадського',
  aboutAuthorWork6:
    "Вивчаю кармічний менеджмент і причинно-наслідкові зв'язки в Інституті Азійської Класики",
  aboutKarmaTitle: 'Що таке карма і як вона працює?',
  aboutKarmaDesc1: 'Вченню про карму понад 2,5 тисячі років',
  aboutKarmaDesc2: '«Карма» в перекладі з санскриту означає «дія» або «вчинок»',
  aboutKarmaNearHands:
    'Думки, слова, вчинки - це все дії, які ми здійснюємо щоденно.',
  aboutKarmaTextUnderContainer:
    'Всі вони неминуче призведуть до наслідків чи результатів. Ці результати формують наш подальший шлях і долю в цілому.',
  aboutKarmaResultText: 'Все приносить свої плоди!',
  whatIsMatrixTitle1: 'Що таке',
  whatIsMatrixTitle2: 'Матриця Долі?',
  whatIsMatrixMatrixCreator:
    'Авторський метод Наталії Ладіні, якому вже понад 16 років',
  whatIsMatrixAboutMethod:
    'Цей метод фактично є відображенням вашої карми, а також унікальним інструментом для діагностики призначення, зцілення душі, розуму і тіла',
  whatIsMatrixLinkToCalculator: 'Розрахувати матрицю',
  matrixMinusAndPlusTitle1: 'Матриця в мінусі',
  matrixMinusAndPlusTitle2: 'Матриця в плюсі',
  matrixMinusAndPlusCheckboxText: 'Пропрацювати матрицю',
  matrxiMinusPuzzle: 'постаєш перед фінансовими труднощами',
  waysToTransformationTitle: 'Я проведу тебе до істинних бажань твоєї душі.',
  waysToTransformationAbout:
    'Ти не залишишся наодинці з багажем нової інформації про себе, оскільки я гарантую:',
  waysToTransformationWarning:
    '*Необережне відкриття доленосних програм, без готовності працювати над ними, може мати негативні наслідки. Тому для вашої безпеки всі повноцінні консультації по матриці НЕ проводяться без готовності клієнта йти до трансформації.',
  waysToTransformationConsultationTitle: 'На  Консультації',
  waysToTransformationConsultationText1:
    'Індивідуальний підхід до кожного клієнта',
  waysToTransformationConsultationText2:
    "Унікальні інтерпретації зв'язків енергій у твоїй матриці",
  waysToTransformationConsultationText3:
    'Інформацію, яка з часом розкриється на новому, глибинному рівні',
  waysToTransformationTransformationWayTitle: 'На  Трансформації',
  waysToTransformationTransformationWayText1:
    'Енергетичну та інформаційну підтримку',
  waysToTransformationTransformationWayText2:
    'Надання комплексу рекомендацій та матеріалів - кармічний рецепт',
  waysToTransformationTransformationWayText3:
    'Різноманітні методики та практики',
  waysToTransformationTransformationWayText4:
    'Відстеження процесу трансформації за допомогою точок контролю між етапами у форматі дзвінків',
  ServicesAndPriceTitle: 'Послуги',
  ServicesAndPriceFourStages: 'Глибинна робота: 4 рівні матриці',
  ServicesAndPriceWarning: '*Кожен рівень опрацьовується послідовно',
  ServicesAndPriceDetail: 'Детальніше',
  ServicesAndPriceConsultationsIndividualRequest:
    'Також можна розібрати будь-яку іншу тему за індивідуальним запитом.',
  ServicesAndPriceConsultationsTitle: 'Консультації',
  ServicesAndPriceExpressServicesTitle: 'Експрес-послуги',
  ServicesAndPriceExpressServicesAdditionalInfo1:
    'Також ви можете подарувати своїм близьким',
  ServicesAndPriceExpressServicesAdditionalInfo2: 'на будь-яку послугу.',
  ServicesAndPriceExpressServicesCert: 'сертифікат',
  masterClassTitle: 'Авторські <1>майстер-класи</1>',
  cost: 'Вартість:',
  feedback: 'Відгуки',
  feedbackDesc: 'Я з радістю стану твоїм провідником у новий етап твого життя!',
  calculate: 'Дізнайся',
  yourMatrix: 'свою Матрицю Долі',
  aboutCalc: 'Поглиблений калькулятор для швидкого та професійного розрахунку.',
  infoAboutCalc:
    '* Калькулятор на 100% відповідає класичному обчисленню «Матриця Долі» Наталії Ладіні',
  calcBtn: 'Розрахувати',
  freeRecommendationTitle: 'Багато корисної інформації у моїх соц.мережах:',
  peopleAsk: 'Мене часто запитують',
  FourLevels: '4  рівні матриці',
  aboutMethods: 'Про метод',
  policy: 'Політика конфіденційності',
  designedBy: 'Дизайн сайту by shlm.anna',
};

export default mainUa;
